module.exports = __webpack_public_path__ + "img/guanwang.196d6941.jpg";